module.exports = __webpack_public_path__ + "static/media/Logo_adam_color.6b92c7fb.png";